import SubscriptionOverviewV1 from './SubscriptionsV1';
import SubscriptionOverviewV2 from './SubscriptionsV2';

import { useSubscriptionV2 } from '../../utilities/helpers';

const SubscriptionOverview = () => {
  const isV2Enabled = useSubscriptionV2();

  return <>{isV2Enabled ? <SubscriptionOverviewV2 /> : <SubscriptionOverviewV1 />}</>;
};

export default SubscriptionOverview;
